import React from 'react';
import { reduxForm, InjectedFormProps, reset, FieldArray } from 'redux-form';
import { Form, Card, Button, Spin } from 'antd';
import { SkeletonHOC, ButtonTypes, IconTypeNames, scrollTop } from 'common';
import { compose } from 'redux';

import styles from './XosImage.module.scss';
import {
  XOSIMAGE_FORM,
  XOSIMAGE_FORM_INITIAL_VALUES,
} from './XosImage.constants';
import { useDispatch } from 'react-redux';
import { XosImageStates } from './models';
import { resetResults, searchXosImage } from '.';
import { XosImageItemsGroup } from './components';
import { useAccount, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { getAccessToken } from 'common/helpers';

interface XosImageFormProps {
  xosImagesStates: XosImageStates;
  handleSubmit: any;
  loading: boolean;
  valid: boolean;
  stateHob: string;
  countyHob: string;
  formValues: any;
}

type Props = XosImageFormProps & InjectedFormProps<{}, XosImageFormProps>;

const XosImageForm: React.FC<Props> = ({
  xosImagesStates,
  loading,
  valid,
  formValues,
}: XosImageFormProps) => {
  console.log('inside form prop');
  const dispatch = useDispatch();
  const handleResetForm = () => {
    dispatch(resetResults());
    dispatch(reset(XOSIMAGE_FORM));
  };
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  const handleSearch = (format: string) => {
    if (account && inProgress === InteractionStatus.None) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken)
          dispatch(searchXosImage(formValues, format, response.accessToken));
      });
    }
    scrollTop();
  };

  return (
    <Card size="small">
      <Spin spinning={loading} size="large" tip="Loading...">
        <Form layout="vertical">
          <label htmlFor="firstName">First Name</label>
          <FieldArray
            name={`items`}
            component={XosImageItemsGroup}
            xosImagesStates={xosImagesStates}
          />
          <Button
            type={ButtonTypes.GHOST}
            onClick={handleResetForm}
            className={styles.button}
          >
            Reset
          </Button>
          <Button
            disabled={loading || !valid}
            icon={IconTypeNames.PDF}
            type={ButtonTypes.PRIMARY}
            htmlType="submit"
            onClick={() => handleSearch('pdf')}
            className={styles.button}
          >
            Export as PDF
          </Button>
          <p
            style={{ display: 'inline', color: '#40a9ff', fontWeight: 'bold' }}
          >
            *
          </p>
          <p style={{ display: 'inline' }}>Fee applied on Export</p>
          <p
            style={{ display: 'inline', color: '#40a9ff', fontWeight: 'bold' }}
          >
            *
          </p>
        </Form>
      </Spin>
    </Card>
  );
};

export default compose(
  SkeletonHOC({ initProp: 'xosImagesStates', rows: 12 }),
  reduxForm<{}, XosImageFormProps>({
    form: XOSIMAGE_FORM,
    initialValues: XOSIMAGE_FORM_INITIAL_VALUES,
  }),
)(React.memo(XosImageForm));
